import React, { type FormEventHandler } from 'react'
import { useError, useMutation } from '@ztechapps/common.hook'
import { ShowIf } from '@ztechapps/webui.util'
import { ButtonGroup, Stack } from 'react-bootstrap'
import { TextAreaInput } from '@ztechapps/webui.input'
import { BusyButton } from '@ztechapps/webui.button'
import isEmpty from 'lodash/isEmpty'
import { AddNewActivityButton } from '../AddNewActivityButton'
import type { Activity } from '@ztechapps/common.contract'
import { mutationCreateRemarksActivity } from '../graphql'
import { useActivityContext } from '../Context'

export const placeholder = 'Type an activity or remarks here. Press "Escape" key to cancel or "Shift + Enter" to save.'

export const AddActivityInput = () => {
  const { entityName, documentId, disabled, showInput, setShowInput, activities, onKeyDown, reset } =
    useActivityContext()

  const addMutation = useMutation<Activity>({ query: mutationCreateRemarksActivity(entityName) })

  const [onAdd, , { loading, error }] = addMutation ?? []

  const [newActivity, setNewActivity] = React.useState('')

  useError(error)

  const onSubmit: FormEventHandler<any> = async (e) => {
    e.preventDefault()

    await onAdd({ input: { activity: newActivity }, filter: { _id: documentId } })

    handleReset()
  }

  const handleReset = () => {
    reset()
    setNewActivity('')
    setShowInput(false)
  }

  return (
    <ShowIf condition={!disabled}>
      <ShowIf condition={showInput}>
        <form onSubmit={onSubmit} onReset={handleReset}>
          <Stack gap={2}>
            <TextAreaInput
              placeholder={placeholder}
              disabled={loading}
              onChange={(e) => setNewActivity(e.target.value)}
              value={newActivity}
              onKeyDown={(e) => {
                onKeyDown(e, onSubmit)
              }}
            />

            <div>
              <ButtonGroup size="sm">
                <BusyButton
                  type="submit"
                  disabled={!newActivity}
                  isBusy={loading}
                  text="Add"
                  icon="plus"
                  busyText="Adding..."
                  title="Add new activity"
                />
                <BusyButton type="reset" text="Cancel" icon="ban" title="Cancel changes" bsStyle="secondary" />
              </ButtonGroup>
            </div>
          </Stack>
        </form>
      </ShowIf>

      <ShowIf condition={!showInput && !isEmpty(activities)}>
        <AddNewActivityButton />
      </ShowIf>
    </ShowIf>
  )
}
